import { useTranslation } from 'react-i18next';

import Button from '../../../../../components/Button';
import Tooltip from '../../../../../components/Tooltip';
import { i18nNS } from '../../../../../i18n';
import SettingsIcon from '../../../../../icons/SettingsIcon';
import EditPublishPreferencesDrawer from '../EditPublishPreferencesDrawer';
import useEditPublishPreferences from './vm';

export interface EditPublishPreferencesProps {
  isClassClosed: boolean;
}

const EditPublishPreferences = ({ isClassClosed }: EditPublishPreferencesProps) => {
  const { t } = useTranslation([i18nNS.POLL]);

  const {
    isEditPublishPreferencesDrawerOpen,
    handleEditPublishPreferences,
    handleCloseEditPublishPreferencesDrawer,
  } = useEditPublishPreferences();
  return (
    <>
      <Tooltip title={t('edit_preferences', { ns: i18nNS.POLL })}>
        <Button variant="text" size="small" onClick={handleEditPublishPreferences} disabled={isClassClosed}>
          <SettingsIcon size={20} />
        </Button>
      </Tooltip>
      <EditPublishPreferencesDrawer
        open={isEditPublishPreferencesDrawerOpen}
        onClose={handleCloseEditPublishPreferencesDrawer}
      />
    </>
  );
};

export default EditPublishPreferences;
